class FAQs extends HTMLElement {
    constructor() {
        super();

        this.filter = this.querySelector('#haloFAQsFilter');
        this.faqsPopup = this.querySelector('#halo-faqs-popup');
        this.tabButtons = Array.from(this.querySelectorAll('[data-faq-tab]'));
        this.tabPanels = Array.from(this.querySelectorAll('[data-faq-tab-panel]'));

        if(this.filter){
            this.filterToggle = this.filter.querySelector('[data-faqs-filter]');
            this.filterDropdown = this.filter.querySelector('.faqs-filterDropdown-menu');
            this.filterDropdownArrow = this.filterToggle.querySelector('[data-dropdown-arrow]')
            
            if(this.filterToggle){
                this.filterToggle.addEventListener('click', this.onClickFilterHandler.bind(this));
            }

            if(this.filterDropdown.querySelector('.text')){
                this.filterDropdown.querySelectorAll('.text').forEach((filterButton) => {
                    filterButton.addEventListener('click', this.onClickFilterButtonHandler.bind(this));
                });
            }
        }

        if(this.querySelector('.faqs')){
            this.querySelectorAll('.card-header').forEach((headerButton) => {
                headerButton.addEventListener('click', this.onClickHeaderButtonHandler.bind(this));

                if (!headerButton.classList.contains('collapsed')) {
                    const content = headerButton.nextElementSibling;
                    if (content) content.style.maxHeight = content.scrollHeight + 'px';
                }
            });
        }

        this.tabButtons.forEach((tabButton) => {
            tabButton.addEventListener('click', this.onClickTabHandler.bind(this));
            tabButton.addEventListener('keydown', this.onKeydownTabHandler.bind(this));
        });

        this.onBlockSelectHandler = this.onBlockSelectHandler.bind(this);
        document.addEventListener('shopify:block:select', this.onBlockSelectHandler);

        if(!document.body.classList.contains('template-index')){
            document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
        }
    }

    onClickFilterHandler(){
        if(this.filterDropdown.classList.contains('is-show')){
            this.filterDropdown.classList.remove('is-show');
            this.filterDropdownArrow.classList.remove('active')
        } else {
            this.filterDropdown.classList.add('is-show');
            this.filterDropdownArrow.classList.add('active')
        }
    }

    onClickFilterButtonHandler(event){
        var btn = event.target.closest('li');

        if(!btn.classList.contains('is-active')){
            var filterValue = btn.getAttribute('data-value'),
                filterText = event.target.innerText;

            this.filterToggle.querySelector('.text').innerText = filterText;

            this.filterDropdown.querySelectorAll('li').forEach((element) => {
                element.classList.remove('is-active');
            });

            btn.classList.add('is-active');

            if(filterValue !== undefined && filterValue !== null){
                this.querySelectorAll('.faqs-paragraph').forEach((element) => {
                    var id = element.getAttribute('id');

                    if(id == filterValue){
                        element.classList.remove('is-hidden');
                        element.classList.add('is-active');
                    } else {
                        element.classList.remove('is-active');
                        element.classList.add('is-hidden');
                    }
                });
            } else {

                this.querySelectorAll('.faqs-paragraph').forEach((element) => {
                    element.classList.remove('is-hidden', 'is-active');
                });
            }

            this.filterDropdown.classList.remove('is-show');
            this.filterDropdownArrow.classList.remove('active')
        }
    }

    onClickHeaderButtonHandler(event){
        const btn = event.currentTarget
        const content = btn.nextElementSibling
        const willOpen = btn.classList.contains('collapsed')

        btn.classList.toggle('collapsed');
        btn.setAttribute('aria-expanded', String(willOpen));

        if (content.style.maxHeight){
            content.style.maxHeight = null;
        } else {
            content.style.maxHeight = content.scrollHeight + 'px';
        }
    }

    onClickTabHandler(event) {
        this.activateTab(event.currentTarget);
    }

    onKeydownTabHandler(event) {
        const currentIndex = this.tabButtons.indexOf(event.currentTarget);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabButtons.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabButtons.length) % this.tabButtons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabButtons.length - 1;
        if (nextIndex === currentIndex) return;

        event.preventDefault();
        this.activateTab(this.tabButtons[nextIndex]);
        this.tabButtons[nextIndex].focus();
    }

    activateTab(activeButton) {
        if (!activeButton) return;

        const panelId = activeButton.getAttribute('aria-controls');
        activeButton.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        this.tabButtons.forEach((button) => {
            const isActive = button === activeButton;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-selected', String(isActive));
            button.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.tabPanels.forEach((panel) => {
            const isActive = panel.id === panelId;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
        });
    }

    onBlockSelectHandler(event) {
        if (!this.contains(event.target)) return;

        const tabButton = event.target.closest('[data-faq-tab]');
        if (tabButton) {
            this.activateTab(tabButton);
            return;
        }

        const panel = event.target.closest('[data-faq-tab-panel]');
        if (!panel) return;

        this.activateTab(this.querySelector(`[aria-controls="${panel.id}"]`));
    }

    onBodyClickEvent(event) {
        if (!this.filterDropdown) return
        if (event.target.closest('[data-faqs-filter]') != null) return
        if(this.filterDropdown.classList.contains('is-show')) {
            this.filterDropdown.classList.remove('is-show')
            this.filterDropdownArrow.classList.remove('active')
        }
    }
}

if (!customElements.get('faqs-item')) {
    customElements.define('faqs-item', FAQs);
}
